"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _config = _interopRequireDefault(require("next/config"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _getConfig = (0, _config["default"])(),
    _getConfig$publicRunt = _getConfig.publicRuntimeConfig,
    CONTRACTOR_PAYMENTS_ENABLED = _getConfig$publicRunt.CONTRACTOR_PAYMENTS_ENABLED,
    TIMEOFF_ENABLED = _getConfig$publicRunt.TIMEOFF_ENABLED,
    ADMIN_PAYROLL_ENABLED = _getConfig$publicRunt.ADMIN_PAYROLL_ENABLED,
    ADMIN_ADJUSTMENTS_ENABLED = _getConfig$publicRunt.ADMIN_ADJUSTMENTS_ENABLED,
    PAYMENT_METHODS_ENABLED = _getConfig$publicRunt.PAYMENT_METHODS_ENABLED,
    EXPENSES_ENABLED = _getConfig$publicRunt.EXPENSES_ENABLED,
    INCENTIVES_ENABLED = _getConfig$publicRunt.INCENTIVES_ENABLED,
    TIER_BUILDER_ENABLED = _getConfig$publicRunt.TIER_BUILDER_ENABLED,
    EMPLOYEE_BENEFITS_ENABLED = _getConfig$publicRunt.EMPLOYEE_BENEFITS_ENABLED,
    INTEGRATIONS_ENABLED = _getConfig$publicRunt.INTEGRATIONS_ENABLED,
    ADMIN_EMPLOYMENT_FEES_ENABLED = _getConfig$publicRunt.ADMIN_EMPLOYMENT_FEES_ENABLED,
    ADMIN_PRICING_ENABLED = _getConfig$publicRunt.ADMIN_PRICING_ENABLED;

var employerDefaultAuthorizations = {
  account_preferences: ['read', 'update'],
  dashboard: ['read'],
  people: ['create', 'read', 'update', 'delete'],
  hiring: ['create', 'read', 'update', 'delete'],
  company_details: ['create', 'read', 'update', 'delete'],
  payment_requests: CONTRACTOR_PAYMENTS_ENABLED ? ['create', 'read', 'update', 'delete'] : [],
  payroll: [],
  billing: ['read', 'update'],
  time_off_management: TIMEOFF_ENABLED ? ['read', 'update'] : [],
  expense_management: EXPENSES_ENABLED ? ['read', 'create'] : [],
  incentives_management: INCENTIVES_ENABLED ? ['read', 'update', 'create', 'delete'] : [],
  documents_management: ['read', 'update', 'create', 'delete']
};
var integrations = {
  integrations: INTEGRATIONS_ENABLED ? ['read', 'update', 'create', 'delete'] : []
};

var employerAuthorizations = _objectSpread(_objectSpread({}, employerDefaultAuthorizations), {}, {
  team_members: ['read', 'update', 'create', 'delete'],
  payment_methods: PAYMENT_METHODS_ENABLED ? ['read', 'update', 'create', 'delete'] : []
}, integrations);

var _default = {
  admin: {
    account_preferences: ['read', 'update'],
    admin: ['read'],
    benefits: ['read', 'update', 'create', 'delete'],
    payroll: ADMIN_PAYROLL_ENABLED ? ['read', 'create'] : [],
    adjustments: ADMIN_ADJUSTMENTS_ENABLED ? ['read', 'create'] : [],
    team_members: ['read', 'update', 'create', 'delete'],
    expense_management: EXPENSES_ENABLED ? ['read', 'create', 'update', 'delete'] : [],
    incentives_management: INCENTIVES_ENABLED ? ['read', 'update'] : [],
    norma_playground: ['read'],
    tier_builder: TIER_BUILDER_ENABLED ? ['read'] : [],
    employment_fees: ADMIN_EMPLOYMENT_FEES_ENABLED ? ['read', 'update', 'create', 'delete'] : [],
    pricing: ADMIN_PRICING_ENABLED ? ['read', 'update', 'create', 'delete'] : []
  },
  employer: employerAuthorizations,
  employee: {
    account_preferences: ['read', 'update'],
    personal_information: ['read'],
    documents: ['read'],
    payslips: ['read'],
    invoices: CONTRACTOR_PAYMENTS_ENABLED ? ['read', 'update', 'delete'] : [],
    administrative_details: ['read', 'update'],
    job_pay: ['read', 'update'],
    dashboard: ['read'],
    time_off: TIMEOFF_ENABLED ? ['create', 'read', 'update', 'delete'] : [],
    benefits: EMPLOYEE_BENEFITS_ENABLED ? ['read'] : [],
    expenses: EXPENSES_ENABLED ? ['read', 'create'] : []
  },
  contractor: {
    account_preferences: ['read', 'update'],
    personal_information: ['read'],
    documents: ['read'],
    invoices: CONTRACTOR_PAYMENTS_ENABLED ? ['create', 'read', 'update', 'delete'] : [],
    job_pay: [],
    dashboard: ['read'],
    bank_accounts: ['read', 'create', 'update', 'delete']
  },
  service_provider: {
    dashboard: ['read'],
    account_preferences: ['read', 'update'],
    people: ['read'],
    payroll: ['read']
  },
  teamMember: {
    viewer: _objectSpread({
      dashboard: ['read'],
      people: ['read'],
      company_details: ['read'],
      payment_requests: ['read'],
      payroll: [],
      billing: ['read'],
      payment_methods: PAYMENT_METHODS_ENABLED ? ['read'] : []
    }, integrations),
    admin: _objectSpread(_objectSpread(_objectSpread({}, employerDefaultAuthorizations), integrations), {}, {
      team_members: ['read', 'update', 'create'],
      payment_methods: PAYMENT_METHODS_ENABLED ? ['read', 'update', 'create', 'delete'] : []
    }),
    owner: employerAuthorizations
  }
};
exports["default"] = _default;